import { Box, Flex, Text, Link as RadixLink, Avatar, Button } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getRedirectPath } from '../services/authService';
import { useTheme } from 'next-themes';
const SiteHeader = () => {
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
    const { theme, setTheme } = useTheme();

    return (
        <Box as="header" p="4">
            <Flex justify="between" align="center" width="100%" maxWidth="1080px" mx="auto">
                <Link to="/" style={{ textDecoration: 'none', color: 'var(--gray-12)' }}>
                    <img src="/edusua.svg" alt="EduPro" width="100" />
                </Link>

                <Flex gap="6" align="center">
                    <RadixLink asChild>
                        <Link to="/about" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                            About
                        </Link>
                    </RadixLink>
                    {/* <RadixLink asChild>
                        <Link to="/contact" style={{ textDecoration: 'none', color: 'var(--gray-11)' }}>
                            Contact
                        </Link>
                    </RadixLink> */}
                    {!user.details ? (
                        <Link
                            to="/login"
                            style={{
                                textDecoration: 'none',
                                backgroundColor: 'var(--accent-9)',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '4px'
                            }}
                        >
                            Login
                        </Link>
                    ) : (
                        <Flex gap="3" align="center">
                            <Box
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    backgroundColor: 'var(--gray-5)',
                                    overflow: 'hidden'
                                }}
                            >
                                <Avatar
                                    // src={user.details.profile_picture || "https://placecats.com/300/200"}
                                    src={`${PUBLIC_URL}/storage/${user.details.profile_picture}`}
                                    fallback={user.details.firstname?.[0]}
                                    radius="full"
                                    size="3"
                                />
                            </Box>
                            <Button onClick={() => navigate(getRedirectPath(user.details.role))}>Console</Button>
                        </Flex>
                    )}

                </Flex>
            </Flex>
        </Box>
    );
};

export default SiteHeader;